// lib/licensing/public-key.ts
//
// Clave PÚBLICA ECDSA P-256 de PRODUCCIÓN para verificar licencias on-prem.
// La pública NO es secreta y se commitea sin problema. La privada correspondiente
// vive solo en el secret manager y se usa para emitir tokens — nunca en el repo
// ni en un build. Ver docs/onprem-release.md → "Manejo de la clave de licencia".
//
// Rotada en junio 2026: el par de test anterior se descartó porque su privada
// quedó expuesta. Generar un par nuevo con scripts/gen-prod-license-keys.ts.

export const LICENSE_PUBLIC_KEY =
  "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEkTYG4JtL1za/D3+p+WrXxvpikF/mwhDNYjoysEArDRFpbsE6nPdKb4cYt6fpphJsU2megZGSKODWK2gVYMsXug==";

export const PUBLIC_KEY_NOT_CONFIGURED =
  "LICENSE_PUBLIC_KEY no configurada. Pegar el valor generado por scripts/gen-prod-license-keys.ts en lib/licensing/public-key.ts antes de compilar el build on-prem." as const;
